<template>
  <div class="cont">
    <div class="title">
        <img src="../../../assets/dapingImg/logo.png" style="width:12%;flex-grow:0">
        <div>
            <p class="shijian">{{nowTime}}</p>
            <p class="riqi">{{nowDate}}</p>
        </div>
    </div>
    <div class="zhutiBox">
        <div class="bian">
            <div class="bian1 box1">
                <div class="title1">
                    <div class="biaoti">当日拉运情况</div>
                </div>
                <div style="height:calc(100% - 40px);" id="ysrwzlId">
                  <div style="display: flex;justify-content: space-around;">
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.dzcWeight}}</p><p class="lyTitle">待装车<span style="font-size: 12px;">（吨）</span></p></div>
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.yszWeight}}</p><p class="lyTitle">运输中<span style="font-size: 12px;">（吨）</span></p></div>
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.yxcWeight}}</p><p class="lyTitle">已卸车<span style="font-size: 12px;">（吨）</span></p></div>
                  </div>
                  <div style="display: flex;justify-content: space-around;">
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.dzcNum}}</p><p class="lyTitle">待装车<span style="font-size: 12px;">（趟）</span></p></div>
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.yszNum}}</p><p class="lyTitle">运输中<span style="font-size: 12px;">（趟）</span></p></div>
                    <div style="width: 33%;"><p class="lyCunt">{{drlyShuju.yxcNum}}</p><p class="lyTitle">已卸车<span style="font-size: 12px;">（趟）</span></p></div>
                  </div>
                </div>
            </div>
            <div class="bian1 box1">
              <div class="title1">
                <div class="biaoti">月度优质流向</div>
              </div>
              <div style="height:calc(100% - 40px);" id="ydyzlxId">
              </div>
            </div>
            <div class="bian2 box1">
              <div class="title1">
                <div class="biaoti">客户排行</div>
              </div>
              <div style="height:calc(100% - 48px);margin-top:8px" class="topCon_body table-wrapper" >
                 <div id="table">
                      <div class="tables xmrwBox">
                          <span class="span_one" style="width: 15%;">序号</span>
                          <span class="span_one" style="width: 35%;">客户名称</span>
                          <span class="span_one" >运量(吨)</span>
                          <span class="span_one">趟数</span>
                      </div>
                      <vue-seamless-scroll  :data="kehuPHlist" :class-option="optionSettingXM"  class="seamless-warp2" >
                          <ul class="item xmrwBox">
                          <li  v-for="(item,index) in kehuPHlist"  :key="index"   >
                              <span   style="width: 15%;">{{ index+1 }}</span>
                              <span v-text="item.payee"  style="width: 35%;"></span>
                              <span v-text="item.allWeight"></span>
                              <span v-text="item.wayNum"></span>
                          </li>
                          </ul>
                      </vue-seamless-scroll>
                  </div>
              </div>
            </div>
        </div>
        <div class="center">
            <div class="center1 box1">
              <div class="title1">
                  <div class="biaoti">实时车辆分布图</div>
              </div>
              <div style="height:calc(100% - 80px);position: relative;" >
                <div style="display:flex; justify-content: space-around;width:100%;position:absolute;left: 0;right: 0;z-index: 9999;">
                   <div class="cheshubox" style="color: #ffffff;">
                      <div style="text-align: center;"><span style="font-size: 22px;">{{cheJson.allWeight}}</span> <br><span>总运量(吨)</span></div>
                    </div>
                    <div class="cheshubox" style="color: #ffffff;">
                      <div style="text-align: center;"><span style="font-size: 22px;color:#5bd942">{{cheJson.wayNum}}</span><br><span>总车次</span> </div>
                    </div>
                    <div class="cheshubox" style="color: #ffffff;">
                      <div style="text-align: center;"><span style="font-size: 22px;color:#ff0000">{{cheJson.vehicleNum}}</span><br><span>总车辆</span> </div>
                    </div>
                    <div class="cheshubox" style="color: #ffffff;">
                      <div style="text-align: center;"><span style="font-size: 22px;color:#ff0000">{{cheJson.driverNum}}</span> <br><span>总司机</span></div>
                    </div>
                    <div class="cheshubox" style="color: #ffffff;">
                      <div style="text-align: center;"><span style="font-size: 22px;color:#ff0000">{{cheJson.cysNum}}</span> <br><span>承运商</span></div>
                    </div>
                </div>
                <div id="map" style="width:100%;height:100%"></div>
              </div>
            </div>
            <div class="center2 box1">
                <div class="title1">
                    <div class="biaoti">实时运单</div>
                </div>
                <div style="height:calc(100% - 50px);margin-top:10px" class="topCon_body table-wrapper" >
                    <div id="table" >
                        <div class="tables ssysBox">
                            <span class="span_one" style="width:22%;flex-shrink:0">运单号</span>
                            <span class="span_one">状态</span>
                            <span class="span_one">车牌号</span>
                            <span class="span_one">司机姓名</span>
                             <span class="span_one">货物</span>
                            <span class="span_one">吨位</span>
                            <span class="span_one">起始地</span>
                            <span class="span_one">目的地</span>
                            <span class="span_one">派车时间</span>
                        </div>
                        <vue-seamless-scroll  :data="yunshuList" :class-option="optionSetting"  class="seamless-warp2" >
                            <ul class="item ssysBox">
                            <li  v-for="(item,index) in yunshuList"  :key="index"  :style="item.exceptionTypeName?'color:red':''"    >
                                <span style="width:22%;flex-shrink:0"  >
                                  <span style="width:100%" >{{item.wayNo}}</span>

                                </span>
                                 <span >
                                  {{item.wayState}}
                                </span>
                                <span v-text="item.plateNumber" ></span>
                                <span  v-text="item.driverName" ></span>
                                <span  v-text="item.productTypeName"  ></span>
                                <span v-text="item.dispatchWeight"  ></span>
                                <span v-text="item.startDirection"  ></span>
                                <span v-text="item.endDirection"  ></span>
                                <span v-text="item.createTime"  ></span>
                            </li>
                            </ul>
                        </vue-seamless-scroll>
                    </div>
                </div>
            </div>
        </div>
        <div class="bian">
            <div class="bian1 box1">
              <div class="title1">
                  <div class="biaoti">货物分布</div>
              </div>
              <div style="height:calc(100% - 40px);"  id="hwfbId"></div>
            </div>
            <div class="bian1 box1">
              <div class="title1">
                  <div class="biaoti">分子公司业务排行</div>
              </div>
              <div style="height:calc(100% - 40px);" id="fzgdId"></div>
            </div>
            <div class="bian2 box1">
              <div class="title1">
                  <div class="biaoti">年度走势(万吨)</div>
              </div>
              <div style="height:calc(100% - 50px)" id="ndzsId" >
              </div>
            </div>
        </div>
    </div>

  </div>
</template>
<script>
import DonMessage from '@/utils/message'
import { findRealTimeWayBill, getWayForToday, getAllTotalValue } from '@/api/newTMS'
import { findMolecularCompanyRank, findCargoTypeDistribution, findDirectionTop, findCustomerTop, findCoordinate, findAnnualTrend } from '@/api/data-center-server'
// import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import { emptyFn, toFixed } from '@/utils/util'
import AMap from 'AMap'
export default {
  components: {
  },
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      emptyFn: emptyFn,
      yunshuList: [],
      rencheList: [],
      generalCode: '', // 承运商code
      baojingList: [],
      ssrow: {},
      imgData: [],
      imgList: [],
      dwList: [],
      mapDate: [],
      cheJson: { },
      zuobiaoFlag: 1,
      zuobiaoCont: '',
      vehGps: {},
      kehuPHlist: [],
      drlyShuju: {},
      timer: null,
      timer1: null
    }
  },
  created () {
    this.getDate()
    this.nowTimer = setInterval(this.getDate, 500)
    let that = this
    that.dituFn()
    that.drlyqkFn()// 当日拉运情况
    that.ssysdtfn()// 实时运单
    that.ndzsFn()// 年度走势
    that.fzgsywFn()// 分子公司业务排行
    that.khphFn()// 客户排行
    that.ydyzlxFn()// 月度优质流向
    that.hwfbFn() // 货物分布
    this.timer = setInterval(function () {
      that.ssysdtfn()// 实施运输动态
    }, 60000 * 5)//
    this.timer1 = setInterval(function () {
      that.ssysdtfn()// 实施运输动态
    }, 60000 * 60)//
  },
  destroyed () {
    clearInterval(this.timer)
    clearInterval(this.timer1)
    clearInterval(this.nowTimer)
  },
  methods: {
    // 获取当前时间
    getDate: function () {
      var _this = this
      const dat = new Date()
      const year = dat.getFullYear()
      const month = (dat.getMonth() + 1).toString().padStart(2, 0)
      const day = (dat.getDate()).toString().padStart(2, 0)
      const hours = (dat.getHours()).toString().padStart(2, 0)
      const minutes = (dat.getMinutes()).toString().padStart(2, 0)
      const second = (dat.getSeconds()).toString().padStart(2, 0)
      _this.nowTime = hours + ':' + minutes + ':' + second
      _this.nowDate = year + '/' + month + '/' + day
    },

    // 地图
    async dituFn () {
      let that = this
      await getAllTotalValue().then(res => {
        this.cheJson = res
      }).catch(error => {
        this.$message.error(error.message)
      })
      findCoordinate().then(res => {
        let carList = []
        res.forEach(item => {
          carList.push({
            lnglat: [item.longitude, item.latitude],
            name: item.receivingAreaName,
            value: item.wayNum
          })
        })
        this.initMapgd(carList)
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    initMapgd (carList) {
      // this.map = new AMap.Map('map', {
      //   center: [118.91, 39.43], // [纬度，经度]
      //   resizeEnable: true,
      //   zoom: 12,
      //   mapStyle: 'amap://styles/darkblue'
      // })
      var map = new AMap.Map('map', {
        zoom: 4.1,
        center: [108.94, 34.34],
        mapStyle: 'amap://styles/darkblue',
        zooms: [4, 18]

      })
      // 金色水滴 SVG
      var DROP_SVG = [
        '<svg xmlns="http://www.w3.org/2000/svg" width="44" height="54" viewBox="0 0 44 54">',
        '<defs><radialGradient id="g" cx="40%" cy="35%" r="65%">',
        '<stop offset="0%" stop-color="#F5D87A"/><stop offset="60%" stop-color="#D4A017"/>',
        '<stop offset="100%" stop-color="#A07000"/></radialGradient></defs>',
        '<path d="M22 2C10 2 2 11 2 22c0 14 20 30 20 30s20-16 20-30C42 11 34 2 22 2z"',
        'fill="url(#g)" stroke="#B8860B" stroke-width="1"/></svg>'
      ].join('')

      // 构建标记 DOM（聚合点和单点统一使用）
      function buildDom (num) {
        var s = String(num); var size = s.length > 3 ? '9px' : s.length > 2 ? '11px' : '13px'
        var d = document.createElement('div')
        d.style.cssText = 'position:relative;width:44px;height:54px;cursor:pointer;'
        d.innerHTML = DROP_SVG +
        '<div style="position:absolute;top:10px;left:0;width:44px;text-align:center;' +
        'color:#fff;font-size:' + size + ';font-weight:bold;line-height:1;' +
        'text-shadow:0 1px 2px rgba(0,0,0,.4);pointer-events:none;">' + num + '</div>'
        return d
      }

      // 聚合点渲染：累加所有被合并点的 value
      function renderCluster (ctx) {
        var sum = 0
        ctx.markers.forEach(function (m) {
          var e = m.getExtData()
          if (e && e.value) sum += Number(e.value)
        })
        ctx.marker.setOffset(new AMap.Pixel(-22, -54))
        ctx.marker.setContent(buildDom(sum))
      }

      // 单个点渲染：直接显示该点的 value
      function renderOne (ctx) {
        var data = ctx.data[0]; var v = data.value || 0
        ctx.marker.setOffset(new AMap.Pixel(-22, -54))
        ctx.marker.setContent(buildDom(v))
        ctx.marker.on('click', function () {
          new AMap.InfoWindow({
            content: '<strong>' + data.name + '</strong><br/>数量：' + v,
            offset: new AMap.Pixel(0, -54)
          }).open(map, ctx.marker.getPosition())
        })
      }

      // 组装 Marker 并启动聚合
      var markers = carList.map(function (item) {
        return new AMap.Marker({
          position: new AMap.LngLat(item.lnglat[0], item.lnglat[1]),
          extData: item
        })
      })

      AMap.plugin('AMap.MarkerClusterer', function () {
        new AMap.MarkerClusterer(map, markers, {
          gridSize: 80,
          minClusterSize: 2,
          renderClusterMarker: renderCluster,
          renderMarker: renderOne
        })
      })
      // 省份文字标注（仅缩小时显示）
      var provinces = [
        ['北京', 116.405, 39.905], ['天津', 117.19, 39.126], ['河北', 114.502, 38.045],
        ['山西', 112.549, 37.857], ['内蒙古', 111.671, 40.818], ['辽宁', 123.429, 41.797],
        ['吉林', 125.325, 43.887], ['黑龙江', 126.642, 45.757], ['上海', 121.473, 31.232],
        ['江苏', 118.797, 32.06], ['浙江', 120.154, 30.287], ['安徽', 117.283, 31.861],
        ['福建', 119.306, 26.075], ['江西', 115.892, 28.676], ['山东', 117.001, 36.676],
        ['河南', 113.665, 34.758], ['湖北', 114.299, 30.584], ['湖南', 112.982, 28.194],
        ['广东', 113.264, 23.129], ['广西', 108.32, 22.824], ['海南', 110.331, 20.032],
        ['重庆', 106.505, 29.533], ['四川', 104.066, 30.659], ['贵州', 106.713, 26.578],
        ['云南', 102.712, 25.041], ['西藏', 91.132, 29.66], ['陕西', 108.948, 34.263],
        ['甘肃', 103.834, 36.061], ['青海', 101.779, 36.623], ['宁夏', 106.278, 38.466],
        ['新疆', 87.618, 43.793], ['台湾', 121.509, 25.044], ['香港', 114.173, 22.32]
      ]
      var provMarkers = provinces.map(function (p) {
        var label = document.createElement('div')
        label.style.cssText = 'color:#aaa;font-size:13px;font-weight:bold;' +
    'white-space:nowrap;text-shadow:0 0 4px rgba(0,0,0,.8);pointer-events:none;'
        label.textContent = p[0]
        return new AMap.Marker({
          position: [p[1], p[2]],
          content: label,
          offset: new AMap.Pixel(-20, -10),
          zIndex: 1
        })
      })
      // 初始显示
      provMarkers.forEach(function (m) { m.setMap(map) })

      // 缩放级别切换：zoom > 6 时隐藏省份标注
      map.on('zoomend', function () {
        var show = map.getZoom() <= 4.5
        provMarkers.forEach(function (m) { show ? m.show() : m.hide() })
      })
    },
    // 实时运单
    ssysdtfn () {
      findRealTimeWayBill({}).then(res => {
        this.yunshuList = []
        res.forEach(itme => {
          itme.createTime = itme.createTime.slice(0, 10)
          if (itme.endDirection) {
            let arr1 = itme.endDirection.split('-')
            itme.endDirection = arr1[1] + arr1[2]
          }
          if (itme.startDirection) {
            let arr2 = itme.startDirection.split('-')
            itme.startDirection = arr2[1] + arr2[2]
          }

          this.yunshuList.push(itme)
        })
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 当日拉运情况
    drlyqkFn () {
      getWayForToday().then(res => {
        this.drlyShuju = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 年度走势
    ndzsFn () {
      findAnnualTrend().then(res => {
        let data = []
        let name = []
        res.forEach(item => {
          data.push(item.weight)
          name.push(item.yearMonthTms)
        })
        this.xian(data, name, 'ndzsId')
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    xian (rawValues, months, id) {
      let _this = this
      var numData = rawValues.map(Number)
      var chart = _this.$echarts.init(document.getElementById(id))

      // 计算合理的 Y 轴最小值（不小于 0，且留一点余量）
      var dataMin = Math.min.apply(null, numData)
      var dataMax = Math.max.apply(null, numData)
      var yMin = Math.max(0, Math.floor(dataMin * 0.9))
      var yMax = Math.ceil(dataMax * 1.05)
      // 如果数据范围太小（< 50），适当扩展 Y 轴范围
      if (yMax - yMin < 50) {
        var mid = (yMin + yMax) / 2
        yMin = Math.max(0, Math.floor(mid - 25))
        yMax = Math.ceil(mid + 25)
      }

      chart.setOption({
        legend: { show: false },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(10,26,47,0.95)',
          borderColor: '#00e5ff',
          borderWidth: 1,
          padding: [10, 14],
          textStyle: { color: '#fff', fontSize: 14 },
          formatter: function (params) {
            var p = params[0]
            return '<b style="color:#8ab4d6">' + p.name + '</b><br/>' +
               '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;' +
               'background:#00e5ff;margin-right:8px;box-shadow:0 0 6px #00e5ff"></span>' +
               '<b style="color:#00e5ff;font-size:16px">' + p.value + '</b>'
          }
        },

        grid: {
          left: 80,
          top: 45,
          right: 55,
          bottom: 75
        },

        xAxis: {
          type: 'category',
          data: months,
          boundaryGap: false,

          axisLine: {
            show: true,
            lineStyle: { color: '#1a3a5c', width: 1 }
          },
          axisTick: { show: false },
          axisLabel: {
            interval: 0,
            rotate: 38,
            color: '#8ab4d6',
            fontSize: 12,
            margin: 18
          }
        },

        yAxis: {
          type: 'value',
          min: yMin,
          max: yMax,

          axisLine: { show: false },
          axisTick: { show: false },

          splitLine: {
            lineStyle: {
              color: '#162d4a',
              type: 'dashed'
            }
          },

          axisLabel: {
            color: '#8ab4d6',
            fontSize: 13,
            formatter: function (v) {
              // if (v >= 10000) return (v / 10000).toFixed(1) + 'w'
              // if (v >= 1000) return (v / 1000).toFixed(1) + 'k'

              return (v / 10000).toFixed(1)
            }
          }
        },

        series: [{
          name: '年度走势',
          type: 'line',
          smooth: 0.3,
          symbol: 'circle',
          symbolSize: 8,
          data: numData,

          lineStyle: {
            color: '#00e5ff',
            width: 2.5,
            shadowColor: 'rgba(0,229,255,0.5)',
            shadowBlur: 8,
            shadowOffsetY: 2
          },

          itemStyle: {
            color: '#0a1a2f',
            borderWidth: 2.5,
            borderColor: '#00e5ff',
            shadowColor: 'rgba(0,229,255,0.7)',
            shadowBlur: 8
          },

          areaStyle: {
            color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,229,255,0.32)' },
              { offset: 1, color: 'rgba(0,229,255,0)' }
            ])
          },

          // ★ 每个数据点上方标注数值
          label: {
            show: true,
            position: 'top',
            distance: 10,
            color: '#e0f0ff',
            fontSize: 12,
            fontWeight: 'bold',
            formatter: function (p) {
              var v = p.value
              // if (v >= 1000) return (v / 1000).toFixed(1) + 'k'
              return (v / 10000).toFixed(1)
            }
          },

          emphasis: {
            focus: 'series',
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 3,
              shadowBlur: 16,
              shadowColor: 'rgba(0,229,255,0.9)'
            },
            label: {
              fontSize: 15,
              color: '#fff',
              fontWeight: 'bold'
            }
          }
        }]
      })
    },
    // 分子公司业务排行
    fzgsywFn () {
      findMolecularCompanyRank({
      }).then(res => {
        let data = []
        let name = []
        res.forEach(item => {
          if (data.length < 5) {
            data.push(item.weight)
            name.push(item.subcompanyName)
          }
        })
        this.zhu(data, name, 'fzgdId')
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    zhu (dataArr, name, id) {
      let _this = this
      const myEcharts = _this.$echarts
      let idChart = _this.$echarts.init(document.getElementById(id))
      var seriesOption = {
        grid: {
          left: '5%',
          right: '5%',
          bottom: '0%',
          top: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return (
              params[0].name +
        '<br/>' +
        "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
        params[0].seriesName +
        ' : ' +
        Number(
          (params[0].value.toFixed(4) / 10000).toFixed(2)
        ).toLocaleString() +
        ' 万<br/>'
            )
          }
        },
        backgroundColor: 'rgb(20,28,52,0)',
        xAxis: {
          show: false,
          type: 'value',
          max: function (value) {
            return value.max // ✅ 不留任何额外空白，柱子顶到右边界
          }
        },
        yAxis: [
          {
            type: 'category',
            inverse: true,
            axisLabel: {
              show: false // 彻底关掉左边的文字
            },
            splitLine: { show: false },
            axisTick: { show: false },
            axisLine: { show: false },
            data: name
          },
          {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              textStyle: { color: '#ffffff', fontSize: '12' },
              formatter: function (value) {
                return value + '吨'
              }
            },
            data: dataArr
          }
        ],
        series: [
          {
            name: '金额',
            type: 'bar',
            zlevel: 1,
            barCategoryGap: '80%', // 越大间距越宽
            itemStyle: {
              normal: {
                barBorderRadius: 30,
                color: new myEcharts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: 'rgb(57,89,255,1)' },
                  { offset: 1, color: 'rgb(46,200,207,1)' }
                ])
              }
            },
            barWidth: 16,
            data: dataArr,
            // ✅ 核心：文字放在柱子【正上方】，完全不遮挡，完美对齐
            label: {
              show: true,
              position: 'insideTopLeft',
              align: 'left',
              offset: [0, -20], // 【往上挪28px】，绝对不会被盖住
              color: '#fff',
              fontSize: 14,
              formatter: (params) => params.name
            }
          },
          {
            name: '背景',
            type: 'bar',
            barWidth: 16,
            barCategoryGap: '80%', // 越大间距越宽
            barGap: '-100%',
            data: [dataArr[0], dataArr[0], dataArr[0], dataArr[0], dataArr[0]],
            itemStyle: {
              normal: { color: 'rgba(24,31,68,1)', barBorderRadius: 30 }
            }
          }
        ]
      }

      idChart.setOption(seriesOption)
    },
    // 客户排行
    khphFn () {
      findCustomerTop().then(res => {
        this.kehuPHlist = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 月度优质流向
    ydyzlxFn () {
      findDirectionTop({
      }).then(res => {
        let data = []
        let name = []
        res.forEach(item => {
          if (data.length < 5) {
            if (item.endDirection && item.startDirection) {
              let arr1 = item.startDirection.split('-')
              let arr2 = item.endDirection.split('-')
              name.push(arr1[2] + (arr1[3] ? arr1[3] : '') + ' → ' + arr2[2] + (arr2[3] ? arr2[3] : ''))
              data.push(item.allWeight)
            }
          }
        })
        this.zhu(data, name, 'ydyzlxId')
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 货物分布
    hwfbFn () {
      findCargoTypeDistribution().then(res => {
        let data = []
        res.forEach(item => {
          data.push({ name: item.productTypeName, value: Number(item.weight) })
        })
        if (res.length > 0) {
          data.push({ name: '其他', value: Number(res[0].weight) * 0.4 })
        }

        this.pieChart(data)
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    pieChart (dataArr) {
      console.log(dataArr)
      var img =
  'data:image/png;base64,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'

      var trafficWay = dataArr

      var data = []
      var color = [
        '#00ffff',
        '#00cfff',
        '#006ced',
        '#ffe000',
        '#ffa800',
        '#ff5b00',
        '#ff3000'
      ]
      for (var i = 0; i < trafficWay.length; i++) {
        data.push(
          {
            value: trafficWay[i].value,
            name: trafficWay[i].name,
            itemStyle: {
              normal: {
                borderWidth: 5,
                shadowBlur: 20,
                borderColor: color[i],
                shadowColor: color[i]
              }
            }
          },
          {
            value: 2,
            name: '',
            itemStyle: {
              normal: {
                label: {
                  show: false
                },
                labelLine: {
                  show: false
                },
                color: 'rgba(0, 0, 0, 0)',
                borderColor: 'rgba(0, 0, 0, 0)',
                borderWidth: 0
              }
            }
          }
        )
      }
      var seriesOption = [
        {
          name: '',
          type: 'pie',
          clockWise: false,
          radius: [70, 78],
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: 'outside',
                color: '#ddd',
                formatter: function (params) {
                  var percent = 0
                  var total = 0
                  for (var i = 0; i < trafficWay.length; i++) {
                    total += trafficWay[i].value
                  }
                  percent = ((params.value / total) * 100).toFixed(0)
                  if (params.name !== '') {
                    return (
                      '' +
                params.name +
                '：' +
                percent +
                '%'
                    )
                  } else {
                    return ''
                  }
                }
              },
              labelLine: {
                length: 15, // ✅ 第一段：从30改短到15
                length2: 40, // ✅ 第二段：从100大幅缩短到40
                show: true,
                color: '#00ffff'
              }
            }
          },
          data: data
        }
      ]

      let myChart = this.$echarts.init(document.getElementById('hwfbId'))
      // 绘制图表--柱状
      myChart.setOption({
        backgroundColor: '#0A2E5D',
        color: color,
        title: {
          text: '货物分布',
          top: '48%',
          textAlign: 'center',
          left: '49%',
          textStyle: {
            color: '#fff',
            fontSize: 22,
            fontWeight: '400'
          }
        },
        graphic: {
          elements: [
            {
              type: 'image',
              z: 3,
              style: {
                image: img,
                width: 178,
                height: 178
              },
              left: 'center',
              top: 'center',
              position: [100, 100]
            }
          ]
        },
        tooltip: {
          show: false
        },
        legend: {
          icon: 'circle',
          orient: 'horizontal',
          data: ['火车', '飞机', '客车', '轮渡'],
          bottom: 0,
          align: 'left',
          textStyle: {
            color: '#fff'
          },
          itemGap: 20
        },
        toolbox: {
          show: false
        },
        series: seriesOption
      })
    }
  },
  computed: {
    optionSetting () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    },
    optionSettingXM () {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 8, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  }
}
</script>
<style scoped lang='less'>
.cont{
    width: 100%;
    height: 100vh;
    background:  #072648;
    // background-image: url("../../../assets/dapingImg/bg.jpg");
    background-size:100% 100% ;
    box-sizing: border-box;
}
.cont .title{
    width: 100%;
    background-image: url("../../../assets/dapingImg/title.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content:space-between;
    box-sizing: border-box;
    padding:0 30px;
    .shijian{
        font-family: DINPro-Bold;
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0;
    }
    .riqi{
        font-family: DINPro-Bold;
        font-size: 16px;
        line-height: 28px;
        letter-spacing: 0px;
        color: #ffffff;
        margin: 0;
    }
}
.zhutiBox{
    display: flex;
    justify-content:space-between;
    margin-top: -20px;
}
.box1{
    background-image: url("../../../assets/dapingImg/bj1.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
//     border: 1px solid #3ba1ff;
//     box-sizing: border-box;
}
.bian{
    width:28vw;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bian1{
        width: 100%;
        height: calc(34vh - 34px);
        margin-bottom: 10px;
    }
    .bian2{
        width: 100%;
        height: calc(32vh - 33px); ;
    }
}
.center{
    width: calc(44vw - 20px);
    .center1{
        width: 100%;
        height: calc(68vh - 60px);
        margin-bottom: 10px;
    }
    .center2{
        width: 100%;
        height: calc(32vh - 30px); ;
    }
}
.title1{
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.biaoti{
    height: 100%;
    background-image: url("../../../assets/dapingImg/biaoti.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    font-family: MicrosoftYaHei-Bold;
    font-size: 14px;
    padding: 0 20px;
    line-height:40px;
    letter-spacing: 1px;
    color: #ffffff;
}
.tab{
    height: 50%;
    background-image: url("../../../assets/dapingImg/tab.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    padding: 2px 10px;
    span{
        cursor:pointer;
        padding: 0 10px;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #ffffff;
    }
    .active{
         color: #3ba1ff;
    }
}
//表格滚动
#table {
  width: 100%;
  font-size: 12px;
  overflow: hidden;
  height: 100%;
  .tables {
    width: 100%;
    color: #fff;
    height: 30px;
    line-height: 30px;
    display: flex;
    text-align: center;
    .span_one {
      width: 120px;
      height: 100%;
      background:  linear-gradient(90deg,
        #13326880 0%,
        #1e73f480 46%,
        #13326880 100%);
      margin-right: 1px;
    }
    .span_one:last-child{
         margin-right: 0px;
    }
  }
  .ssysBox .span_one{
    width: 9.5%;
  }
   .xmrwBox .span_one{
    width: 25%;
  }
}

.seamless-warp2 {
  height: 100%;
  width: 100%;
  overflow: hidden;
  ul {
    margin: 0;
  }
  li {
    display: flex;
    width: 100%;
    height: 3vh;
    line-height: 3vh;
    color: #fff;
    span {
      width: 120px;
      height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

  }
  .ssysBox span{
    width: 9.5%;
    font-size: 10px;
  }
  .xmrwBox span{
    width: 25%;
  }
}

/deep/.el-input__inner{
  font-family: MicrosoftYaHei-Bold;
  height: 30px;
  line-height: 30px;
  color: #fff;
  background-color: transparent;
  border:1px solid #3ba1ff;;
  font-size: 12px;
}
/deep/.el-input__icon{
  line-height: 30px;
}
/deep/.el-select .el-input .el-select__caret{
 color: #3ba1ff;;
}
// 弹框样式
/deep/.el-message-box__header {
  border-bottom: 1px solid #dcdfe6;
}
/deep/.el-message-box__title {
  font-size: 16px;
  color: #333;
}
/deep/.el-dialog__headerbtn {
  top: 12px;
  .el-dialog__close {
    color: #fff;
  }
}
/deep/ .el-dialog__title {
  color: #fff;
}
/deep/ .el-dialog__header {
  padding: 8px 20px;
  background-color: #032781;
  border-radius: 4px 4px 0 0;
}
/deep/ .el-dialog--center {
  border-radius: 4px 4px 0 0;
}
// 表格样式
/deep/  .el-table th {
  background: linear-gradient(90deg,
  #0056ff 0%,
  #1e73f4 46%,
  #0056ff 100%);
  height: 40px;
  color: #fff;
}
/deep/  .el-table {
  color: #333;
}
/deep/  .el-table tr {
  height: 32px;
}
/deep/ .el-table tr:nth-child(even) {
  background-color: #f8fafd;
}
/deep/ .el-table__body tr.hover-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/  .el-table__body tr.current-row > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(14, 110, 236, 0.3) !important;
}
/deep/ .el-table .cell {
  text-align: center;
}
.img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
.dituTuli{
  position: absolute;
  bottom: 15px;
  display: flex;
  width: 100%;
  justify-content: center;
  .dituTuliItme{
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dttltb{
    display: inline-block;
    width: 1.5vw;
    height:1.5vh;
    border-radius: 20px;
    background-color: #5bd942;
    margin-right: 10px;
  }
  .dttlzt{
    font-family: SourceHanSansCN-Medium;
    font-size: 14px;
    letter-spacing: 1px;
    color: #ffffff;
  }
}
.boxXS{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0e6eec;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  .cheshubox{
     background-image: url("../../../assets/dapingImg/bj2.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding:6px 20px;
    margin: 2px 0;
    width: 19%;
    box-sizing: border-box;
    background-color: rgba(14, 110, 236, 0.3) !important;
  }
/deep/.amap-info-content{
            background:transparent;
            border: none;
            padding: 0;
        }
/deep/.amap-info-outer, /deep/.amap-menu-oute{
   background:transparent;
}
/deep/ .bottom-center .amap-info-sharp{
  border-top: 8px solid #094add;
}
// .amap-info-close
.lyCunt{
  color:#Fdd143;
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 0;
}
.lyTitle{
  color:#fff;
  font-size: 16px;
   text-align: center;
   margin-top: 0;
}
</style>
